// extracted by mini-css-extract-plugin
module.exports = {"artworkImage":"artworkPicture_artworkImage__On37x","artworkPicture":"artworkPicture_artworkPicture__etg9a"};